import {Component, HostBinding, OnChanges, OnDestroy} from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import {AuthService} from '../../core/security/auth.service';
import {routerFlipTransition} from '../../core/animations/router.animations';
import {passwordValidator} from '../../core/validators/password.validator';
import {matchFields} from '../../core/validators/match-fields.validator';
import {ActivatedRoute} from '@angular/router';
import {ResetPasswordModel} from '../../api/models/reset-password-model';
import { NgIf } from '@angular/common';
import { MatTextInputComponent } from '../../editors/mat-text-input/mat-text-input.component';
import { MatPasswordInputComponent } from '../../editors/mat-password-input/mat-password-input.component';
import { MatButton } from '@angular/material/button';
import { Angular2PromiseButtonModule } from 'angular2-promise-buttons';

@Component({
    selector: 'app-login',
    templateUrl: './create-password.component.html',
    styleUrls: ['./create-password.component.scss'],
    animations: [routerFlipTransition()],
    standalone: true,
    imports: [FormsModule, ReactiveFormsModule, NgIf, MatTextInputComponent, MatPasswordInputComponent, MatButton, Angular2PromiseButtonModule]
})
export class CreatePasswordComponent implements OnChanges, OnDestroy {

  @HostBinding('@routerTransition') routerTransition = '';

  form: UntypedFormGroup;
  submitted: boolean;
  serverError: boolean;
  token: string;
  buttonSubmitPromise: Promise<boolean>;

  private paramsSubscription;
  currentYear: number;

  constructor(private fb: UntypedFormBuilder, private authService: AuthService, private route: ActivatedRoute) {

    this.paramsSubscription = this.route.params.subscribe(params => {
      this.token = params['token']; // --> Name must match wanted parameter
    });

    this.currentYear = new Date().getFullYear();

    this.createForm();
  }

  createForm(): void {

    this.form = this.fb.group({
      'username': ['', [Validators.required, Validators.email]],
      'newPassword': ['', [Validators.required, passwordValidator] ],
      'confirmPassword': ['', Validators.required ]
    },
    {validators: matchFields('newPassword', 'confirmPassword')}
    );
  }

  ngOnChanges() {
    this.submitted = false;
    this.form.reset({});
  }

  ngOnDestroy() {
    this.paramsSubscription?.unsubscribe();
  }

  async onSubmit() {
    this.serverError = false;

    if (this.form.valid) {
      this.buttonSubmitPromise = this.processSubmit();
    }
  }

  async processSubmit(): Promise<boolean> {

    this.submitted = true;
    const reqData = this.prepareFormModel();

    try {
      if (await this.authService.submitResetPassword(reqData)) {
        await this.authService.redirectAfterLogin();
        this.ngOnChanges();
      } else {
        this.serverError = true;
      }
    } catch (e) {
      console.log(e);
      this.serverError = true;
    } finally {
      this.submitted = false;
    }

    return true;
  }

  prepareFormModel(): ResetPasswordModel {
    const formModel = this.form.value;

    return {
      username: formModel.username as string,
      newPassword: formModel.newPassword as string,
      confirmPassword: formModel.confirmPassword as string,
      token: this.token,
    };
  }
}
